import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
function _createMdxContent(props) {
  const _components = {
    br: "br",
    h2: "h2",
    hr: "hr",
    li: "li",
    ol: "ol",
    p: "p",
    strong: "strong",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["サウンドオンライブ株式会社（以下、「当社」といいます。）は、当社が運営する音楽制作マッチングサービス「ONLIVE Studio」（以下「本サービス」といいます。）における、会員の個人情報の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます。）を定めます。", _jsx(_components.br, {}), "\n", "なお、本ポリシーで使用する用語の意味は、別段の記載がある場合を除き、個人情報保護法に準拠するものとします。"]
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
      children: "1. 利用目的"
    }), "\n", _jsx(_components.p, {
      children: "当社は、会員の個人情報を、以下の利用目的の範囲内において取得し、利用いたします。"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "本サービスへの登録及び本サービス利用時の会員認証のため"
      }), "\n", _jsx(_components.li, {
        children: "クリエイター会員（利用規約で定義します）登録のための本人確認及び会員管理のため"
      }), "\n", _jsx(_components.li, {
        children: "本サービスに関するお問い合わせ対応及び会員へのご連絡のため"
      }), "\n", _jsx(_components.li, {
        children: "本サービスの保守及び管理のため"
      }), "\n", _jsx(_components.li, {
        children: "本サービスに関する規約等の変更に関する通知のため"
      }), "\n", _jsx(_components.li, {
        children: "不正行為等の防止及び対処のため"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "2. クレジットカード情報の取扱い"
    }), "\n", _jsxs(_components.p, {
      children: ["当社は、本サービスにおける決済処理のために、ストライプジャパン株式会社（以下「Stripe社」といいます。）が提供する「Stripe Connect」サービス（以下「Stripeサービス」といいます。）を利用しています。", _jsx(_components.br, {}), "\n", "会員のクレジットカード情報はStripeサービスを通じてStripe社が取得しますので、当社は、Stripeサービス利用のための固有情報（アクセストークン）、決済金額その他Stripeサービス利用のために必要となる情報を除き、会員のクレジットカード情報について取得及び収集を行いません。"]
    }), "\n", _jsx(_components.h2, {
      children: "3. 第三者提供"
    }), "\n", _jsx(_components.p, {
      children: "当社は、以下の各号に該当する場合を除き、当社が取り扱う個人情報を第三者に提供することはございません。"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "会員の事前の同意がある場合"
      }), "\n", _jsx(_components.li, {
        children: "個人情報保護法その他の法令で認められる場合、又は法令に基づく場合"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "4. Cookie等の取扱い"
    }), "\n", _jsx(_components.p, {
      children: "本サービスでは、会員に対して適切なサービスを提供するために、Cookie（クッキー）その他のトラッキング又は解析を行うための類似技術（以下総称して「Cookie等」といいます。）を使用しています。"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "本サービス固有のCookie"
        }), _jsx("br", {}), "\n本サービスでは、会員の認証のためにCookieを利用しています。", _jsx(_components.br, {}), "\n", "そのため、Cookieの利用を拒否し、又はCookieを削除した場合は、本サービスで利用できる機能等の一部が制限される場合がございます。", _jsx(_components.br, {}), "\n", "なお、このCookie自体には会員の個人情報は含まれておりません。Cookieを本サービスのウェブサーバーに送信することにより、このウェブサーバー側で会員であることの認証を行っています。"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Googleアナリティクスの利用"
        }), _jsx("br", {}), "\n本サービスにおいて、会員の閲覧履歴の追跡その他の行動解析のために、Googleが提供する「Googleアナリティクス」を利用しています。これにより、当社は、Google又は当社が設定するCookie等を利用して会員の閲覧履歴を収集し、分析・解析を行った結果を受け取ることにより会員の利用状況を把握し、また本サービス及び新しいサービスの企画、開発のために利用する場合がございます。", _jsx(_components.br, {}), "\n", "GoogleによるCookieその他Googleアナリティクスにおけるデータの取扱いについては、同社の下記ページをご覧ください。", _jsx(_components.br, {}), "\n", "・「GOOGLEのサービスを使用するサイトやアプリから収集した情報のGOOGLEによる使用」", _jsx(_components.br, {}), "\n", _jsx("a", {
          href: "https://policies.google.com/technologies/partner-sites",
          target: "_blank",
          rel: "noreferrer noopener",
          className: "underline",
          children: "https://policies.google.com/technologies/partner-sites"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Bugsnagの利用"
        }), _jsx("br", {}), "\n本サービスでは、本サービスの不具合検知のためにSmartBear社が提供する「Bugsnag」を利用しています。", _jsx(_components.br, {}), "\n", "会員の安定性スコア計算のために、匿名IDを作成し、会員が本サービス利用のために使用している端末の専用領域（ウェブブラウザーのローカルストレージ）に記録する場合がございますが、匿名IDには会員個人を特定する情報は含まれておりません。"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "5. 安全管理措置"
    }), "\n", _jsx(_components.p, {
      children: "当社は、当社が取り扱う個人情報の漏洩や滅失等の防止その他個人情報の安全管理のために、以下の各号をはじめとする必要かつ適切な措置を講じます。"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "個人情報の基本的な取扱方法の整備及び責任者による取扱確認"
      }), "\n", _jsx(_components.li, {
        children: "個人情報保護法その他法令や前号の取扱方法に違反している事実又は兆候を把握した場合の責任者への報告連絡体制の整備"
      }), "\n", _jsx(_components.li, {
        children: "個人情報の取扱状況についての定期的な点検及び研修実施並びに就業規則への規定"
      }), "\n", _jsx(_components.li, {
        children: "アクセス認証による個人情報を取扱う者の限定"
      }), "\n", _jsx(_components.li, {
        children: "個人情報が記録された機器、媒体等を持ち運ぶ場合のデータ暗号化、パスワード設定等の措置の実施"
      }), "\n", _jsx(_components.li, {
        children: "個人情報が記録された機器、媒体等を廃棄する場合の責任者による確認の実施"
      }), "\n", _jsx(_components.li, {
        children: "OSのアップデート、セキュリティ対策ソフトウェアの導入等による個人情報を取扱うシステムに対する不正アクセス又は不正ソフトウェアからの保護"
      }), "\n", _jsx(_components.li, {
        children: "メール等により個人情報を含むデータ、ファイル等を送信する場合の、パスワードや有効期限等を設定したクラウドサービスの利用"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "6. 開示等の請求"
    }), "\n", _jsxs(_components.p, {
      children: ["当社は、個人情報保護法の規定に従って、当社が保有する会員の個人情報の開示、訂正、削除、利用停止等の請求に対応いたします。", _jsx(_components.br, {}), "\n", "これらの請求を行う場合は、「7.お問い合わせ先」記載の窓口までご連絡ください。当社所定の方法で本人からの請求であることを確認後に対応いたします。", _jsx(_components.br, {}), "\n", "ただし、以下の各号のいずれかに該当する場合は、開示を行わない場合がございます。"]
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "開示することで本人又は第三者の生命、身体、財産その他の権利利益を害するおそれがある場合"
      }), "\n", _jsx(_components.li, {
        children: "開示することで当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合"
      }), "\n", _jsx(_components.li, {
        children: "開示することが法令に違反することとなる場合"
      }), "\n", _jsx(_components.li, {
        children: "本人からの開示の請求であることが確認できない場合"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "7. お問い合わせ先"
    }), "\n", _jsx(_components.p, {
      children: "当社による個人情報の取扱いに関するご意見、ご質問、苦情のお申出、開示等の請求その他のお問い合わせは、以下の窓口までご連絡ください。"
    }), "\n", _jsxs(_components.p, {
      children: ["サウンドオンライブ株式会社", _jsx(_components.br, {}), "\n", "Email: privacy[at]soundonlive.com"]
    }), "\n", _jsx(_components.h2, {
      children: "8. 本ポリシーの改定"
    }), "\n", _jsxs(_components.p, {
      children: ["当社は、本ポリシーの全部又は一部を改定することがあります。改定した場合には当社のウェブサイト又は本サービス内での掲載その他適切な方法により公表いたします。", _jsx(_components.br, {}), "\n", "ただし、法令の規定に基づき会員本人の同意が必要であると判断したときは、当社は適切な方法により会員の同意を得るようにいたします。"]
    }), "\n", _jsx(_components.h2, {
      children: "9. 個人情報取扱事業者"
    }), "\n", _jsxs(_components.p, {
      children: ["〒155-0031 東京都世田谷区北沢2-1-9 第2熊崎ビル 2F", _jsx("br", {}), "\nサウンドオンライブ株式会社", _jsx("br", {}), "\n代表取締役　宮西 洋充"]
    }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.p, {
      children: "2023年6月2日　制定"
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
